import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";

import { Entity } from "@/jenesys-types/data/common";

export interface DataAdapterState extends EntityState<Entity, string> {}

const dataAdapter = createEntityAdapter<Entity>({});

export default dataAdapter;
